import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Delete.module.scss';

const DeleteButton = ({ onClick, className, iconClassName, children, ...props }) => (
  <button type="button" className={cn(styles.button, className)} onClick={onClick} {...props}><i className={iconClassName} />{children}</button>
);

DeleteButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  children: PropTypes.node
};

DeleteButton.defaultProps = {
  onClick() {},
  className: '',
  iconClassName: 'la la-times-circle',
  children: null
};

export default DeleteButton;
